import repository from 'dy-frontend-http-repository/lib/repository';
import { TaskKanbanResource } from 'dy-frontend-http-repository/lib/modules/TaskKanban/resources';
import { ClientUserListItemResource } from 'dy-frontend-http-repository/lib/modules/ClientUser/resources';
import { TeamResource } from 'dy-frontend-http-repository/lib/modules/Filter/resources';
import domain from './domain';
import { TaskKanbanBoardFilterInput } from '../types';

// Client inventory is walked at the API maximum page size until the paginator reports no more pages
const clientInventoryPageLimit = 100;
const clientInventoryMaxPageCount = 50;

// Get kanban board
export const fetchTaskKanbanBoard = domain.createEffect<TaskKanbanBoardFilterInput, TaskKanbanResource>({
    name: 'fetchTaskKanbanBoard',
    handler: async (filter) => {
        return await repository.taskKanban().get(filter);
    },
});

// Get every team available for the kanban team filter
export const fetchTaskKanbanFilterTeams = domain.createEffect<void, TeamResource[]>({
    name: 'fetchTaskKanbanFilterTeams',
    handler: async () => {
        const staticData = await repository.filter().getStaticData({ team: '1' });

        return staticData.team;
    },
});

// Get every accessible active client for the kanban client filter
export const fetchTaskKanbanFilterClients = domain.createEffect<void, ClientUserListItemResource[]>({
    name: 'fetchTaskKanbanFilterClients',
    handler: async () => {
        const clients: ClientUserListItemResource[] = [];
        const addedClientIds: { [id in ID]: boolean } = {};

        let hasMoreClients = false;
        for (let page = 0; page < clientInventoryMaxPageCount; page++) {
            const clientCollection = await repository.clientUser().get(
                { _pagination: { limit: clientInventoryPageLimit, offset: page * clientInventoryPageLimit } },
                { is_shutdown: '0', is_verified: '1' }
            );

            clientCollection.items.forEach((client) => {
                if (addedClientIds[client.id]) {
                    // Client was already collected on an earlier page
                    return;
                }

                addedClientIds[client.id] = true;
                clients.push(client);
            });

            hasMoreClients = clientCollection.paginator?.has_more ?? false;
            if (!hasMoreClients) {
                break;
            }
        }

        if (hasMoreClients) {
            throw new Error('Client inventory exceeded the safe pagination limit');
        }

        return clients;
    },
});
